module.exports = __webpack_public_path__ + "static/img/han.1be697a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/han.jpg
// module id = YMie
// module chunks = 0